import { RouteType } from "types/RouteType";

/**
 * Global 404 route. RouterStore.goTo falls back here when asked for an
 * unknown route name, and loadRouteFromLocation lands here for unmatched
 * URL paths (the bare '/' path still goes to the default route).
 *
 * Hidden from menus; requires auth like every real app route so a dead link
 * never becomes an unauthenticated surface.
 */
const notFoundRoute: RouteType = {
  name: "NotFound",
  path: "/not-found",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Page Not Found",
    },
    body: {
      component: () => import("./NotFound"),
      grayBackground: true,
    },
  },
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  hidden: true,
};

export default notFoundRoute;
